// 字段  文案  全集合
export const FIELD_TEXT_MAP = new Map([
  ['id', '线索ID'],
  ['city', '城市'],
  ['name', '姓名'],
  ['phone', '手机号'],
  ['gmtCreate', '创建时间'],
  ['channelTypeName', '渠道类型'],
  ['channelName', '渠道名称'],
  ['state', '线索状态'],
  ['storeName', '归属门店'],
  ['label', '线索标签'],
  ['goodsId', '商品ID'],
  ['goodsName', '商品名称'],
  ['carBrand', '车辆品牌'],
  ['carSeries', '车系'],
  ['planName', '租赁方案名称'],
  ['rentAmount', '租金'],
  ['rentCycle', '租期'],
  ['depositAmount', '押金'],
  ['orderId', '订单ID'],
  ['plateNo', '车牌号'],
  ['brandName', '品牌'],
  ['seriesName', '车系'],
  ['carModel', '车型'],
  ['orderState', '订单状态'],
  ['rentCategory', '租赁模式'],
  ['orderCreateTime', '订单创建时间'],
  ['clueFollowList', '跟进记录'],
  ['followTime', '跟进时间'],
  ['clueState', '线索状态'],
  ['followRemarks', '跟进描述'],
  ['nextFollowTime', '下次跟进时间'],
  ['followUser', '跟进人'],
  ['gmtRecycling', '回收时间'],
])


// 根据这里配置 src/components/BaseComponents/BaseForm/config/index.js
// 目前只能 componentsType 写死 后续可根据数据类型抽象
export const FORM_ITEM_ARR = [
  {
    label: FIELD_TEXT_MAP.get('name'),
    field: 'name',
    elConfig: {
      placeholder: '请输入姓名',
    },
  },
  {
    label: FIELD_TEXT_MAP.get('city'),
    field: 'city',
    componentsType: 'select',
    elConfig: {
      placeholder: '请输入城市名称',
      filterable: true,
      clearable: true,
      options: {
        label: 'city',
        value: 'cityCode',
        list: [],
      },
    },
    itemConfig: {
      prop: 'cityCode',
    },
  },
  {
    label: FIELD_TEXT_MAP.get('channelTypeName'),
    field: 'channelType',
    componentsType: 'select',
    itemConfig: {
      // 保持跟给后端的参数一致
      prop: 'channelType',
    },
    elConfig: {
      clearable: true,
      options: {
        label: 'name',
        value: 'code',
        list: [],
      },
    },
  },
  {
    label: FIELD_TEXT_MAP.get('channelName'),
    field: 'channel',
    componentsType: 'select',
    itemConfig: {
      // 保持跟给后端的参数一致
      prop: 'channelName',
    },
    elConfig: {
      disabled: false,
      options: {
        label: 'name',
        value: 'name',
        list: [],
      },
    },
  },
  {
    label: FIELD_TEXT_MAP.get('gmtCreate'),
    field: 'gmtCreate',
    componentsType: 'date-picker',
  },
  {
    label: FIELD_TEXT_MAP.get('label'),
    field: 'label',
    componentsType: 'input',
  },
  {
    label: FIELD_TEXT_MAP.get('id'),
    field: 'id',
    componentsType: 'input',
  },
  {
    label: FIELD_TEXT_MAP.get('state'),
    field: 'state',
    hidden: true,
  },
  {
    label: FIELD_TEXT_MAP.get('storeName'),
    field: 'storeName',
    componentsType: 'select',
    elConfig: {
      placeholder: '请输入归属门店',
      filterable: true,
      clearable: true,
      options: {
        label: 'storeName',
        value: 'storeId',
        list: [],
      },
    },
    itemConfig: {
      prop: 'storeId',
    },
  },
  {
    label: '最近跟进时间',
    field: 'followTime',
    componentsType: 'date-picker',
  },
  {
    label: FIELD_TEXT_MAP.get('nextFollowTime'),
    field: 'nextFollowTime',
    componentsType: 'date-picker',
  },
  {
    label: '当前跟进人',
    field: 'followUser',
    componentsType: 'select',
    elConfig: {
      placeholder: '请选择跟进人',
      filterable: true,
      clearable: true,
      options: {
        label: 'userName',
        value: 'id',
        list: [],
      },
    },
    itemConfig: {
      prop: 'followUser',
    },
  },
]

// 销售线索状态
export const STATUS_ALL = '全部'
export const STATUS_TO_FOLLOW_UP = '待跟进'
export const STATUS_IN_THE_FOLLOW_UP = '跟进中'
export const STATUS_HAVE_ORDER = '已到店'
export const STATUS_PICK_UP_THE_CAR_HAS_BEEN = '已提车'
export const STATUS_INVALID = '无效'

// 线索状态枚举值
export const STATUS_ENUM = {
  TO_FOLLOW: 0, // 待跟进
  FOLLOWING: 10, // 跟进中
  ARRIVED: 20, // 已到店
  ORDERED: 30, // 已提车
  INVALID: 40, // 无效
}
/**
 * @STATUS_ARR 销售线索状态
 * 应后端来存储
 */
export const STATUS_ARR = [
  {
    label: STATUS_ALL,
    field: 'all',
    fieldNum: 'allNum',
    value: '',
  },
  {
    label: STATUS_IN_THE_FOLLOW_UP,
    field: 'following',
    fieldNum: 'followingNum',
    value: STATUS_ENUM.FOLLOWING,
  },
  {
    label: STATUS_HAVE_ORDER,
    field: 'ordered',
    fieldNum: 'orderedNum',
    value: STATUS_ENUM.ARRIVED,
  },
  {
    label: STATUS_PICK_UP_THE_CAR_HAS_BEEN,
    field: 'picked',
    fieldNum: 'pickedNum',
    value: STATUS_ENUM.ORDERED,
  },
  {
    label: STATUS_INVALID,
    field: 'invalid',
    fieldNum: 'invalidNum',
    value: STATUS_ENUM.INVALID,
  },
]

// 列字段集合 控制列的顺序
export const COLUMN_FIELD = [
  'id',
  'city',
  'channelTypeName',
  'channelName',
  'name',
  'gmtCreate',
  'label',
  'state',
  'storeName',
  'followTime',
  'nextFollowTime',
  'followUser',
  'followRemarks',
]

// 标签类型
export const TAG_TYPE_ENUM = {
  // 意向确认
  HIGH_INTENTION: 10,
  // 高潜成交
  HIGH_POTENTIAL: 30,
  // 无意向
  NO_INTENTION: 50,
}
export const TAG_TYPE_MAP = {
  [TAG_TYPE_ENUM.HIGH_INTENTION]: '意向确认',
  [TAG_TYPE_ENUM.HIGH_POTENTIAL]: '高潜成交',
  [TAG_TYPE_ENUM.NO_INTENTION]: '无意向',
}
